export default "__VITE_ASSET__DGdPMHLm__"